import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-load-general',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './load-general.component.html',
  styleUrl: './load-general.component.scss',
})
export class LoadGeneralComponent {
  load = input(true);
}
